import { SYSTEM_SINGLE_RATES_VALUES } from '../constants'

// Рассчитывает вознаграждение для новых партнеров
const getNewPartnerReward = (turnovers: { [code: string]: number } | null): number | null => {
  if (!turnovers) {
    return null
  }

  const entries = Object.entries(turnovers)

  if (entries.length === 0) {
    return null
  }

  const total = entries.reduce((sum, [code, turnover]) => {
    const ratePercent = SYSTEM_SINGLE_RATES_VALUES[code]

    const numberRatePercent = ratePercent ? parseInt(ratePercent, 10) : 0

    return sum + turnover * (numberRatePercent / 100)
  }, 0)

  return total
}

export default getNewPartnerReward
